import React from "react";
import { Calendar } from "lucide-react";
import { getCardStyle } from "../../styles/attendanceStyles";
import StatusFilterTabs from "./StatusFilterTabs";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import EmptyState from "./EmptyState";
import useScreenSize from "../../../../hooks/useScreenSize";


const AttendanceTable = ({
  theme,
  isRTL,
  t,
  language,
  filteredAttendance,
  filterStatus,
  setFilterStatus,
  searchTerm,
  setSearchTerm,
  viewType,
  companyConfigs,
  canResetCheckIn,
  canResetCheckOut,
  canRevertOriginal,
  canViewAttendance,
  // ── overtime approval ──────────────────────────────────────────────────────

  // ──────────────────────────────────────────────────────────────────────────
  getConfigForEmployee,
  getEmployeeName,
  updateAttendancein,
  updateAttendanceout,
  revertAttendanceToOriginal,
  fetchEmployeeHistory,
  showAlert,
  BASE_URL,
  children,
}) => {
  // Phones get one card per record instead of a 900px-wide table.
  const { isMobile, isTablet } = useScreenSize();
  const rowProps = (record) => ({
    record,
    theme,
    isRTL,
    t,
    language,
    viewType,
    companyConfigs,
    canResetCheckIn,
    canResetCheckOut,
    canRevertOriginal,
    canViewAttendance,
    getConfigForEmployee,
    getEmployeeName,
    updateAttendancein,
    updateAttendanceout,
    revertAttendanceToOriginal,
    fetchEmployeeHistory,
    showAlert,
    BASE_URL,
  });
  return (
    <div className="nx-section-card" style={getCardStyle(theme)}>
      <h3
        style={{
          fontSize: "18px",
          fontWeight: "700",
          marginBottom: "16px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flexDirection: "row",
          textAlign: isRTL ? "right" : "left",
        }}
      >
        <Calendar size={20} />
        {t.dailyAttendance}
      </h3>

      <StatusFilterTabs
        theme={theme}
        isRTL={isRTL}
        t={t}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
      />

      <div style={{ marginTop: "16px", overflow: "auto", borderRadius: "12px" }}>
        {filteredAttendance.length > 0 && (isMobile || isTablet) ? (
          <div className="nx-mcard-list" style={{ display: "grid", gridTemplateColumns: isTablet ? "repeat(2, minmax(0, 1fr))" : "1fr", gap: "12px", alignItems: "start" }}>
            {filteredAttendance.map((record) => (
              <TableRow key={record.id} {...rowProps(record)} asCard />
            ))}
          </div>
        ) : filteredAttendance.length > 0 ? (
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: "0",
              direction: isRTL ? "rtl" : "ltr",
              minWidth: "900px",
              position: "relative",
              zIndex: 1,
            }}
          >
            <TableHeader theme={theme} isRTL={isRTL} t={t} />
            <tbody>
              {filteredAttendance.map((record) => (
                <TableRow
                  key={record.id}
                  record={record}
                  theme={theme}
                  isRTL={isRTL}
                  t={t}
                  language={language}
                  viewType={viewType}
                  companyConfigs={companyConfigs}
                  canResetCheckIn={canResetCheckIn}
                  canResetCheckOut={canResetCheckOut}
                  canRevertOriginal={canRevertOriginal}
                  canViewAttendance={canViewAttendance}


                  getConfigForEmployee={getConfigForEmployee}
                  getEmployeeName={getEmployeeName}
                  updateAttendancein={updateAttendancein}
                  updateAttendanceout={updateAttendanceout}
                  revertAttendanceToOriginal={revertAttendanceToOriginal}
                  fetchEmployeeHistory={fetchEmployeeHistory}
                  showAlert={showAlert}
                  BASE_URL={BASE_URL}
                />
              ))}
            </tbody>
          </table>
        ) : (
          <EmptyState
            theme={theme}
            t={t}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            setFilterStatus={setFilterStatus}
          />
        )}
      </div>
      {children}
    </div>
  );
};

export default AttendanceTable;